import { Page, useThemeProvider } from "@towersystems/roam-common-native";
import { LoaderScreen, View } from "react-native-ui-lib";

export type LoadingScreenProps = {
  message?: string;
};

export function LoadingScreen({ message }: LoadingScreenProps) {
  const { colors } = useThemeProvider();

  return (
    <Page>
      <View flex style={{ alignItems: "center", justifyContent: "center" }}>
        <View>
          <LoaderScreen message={message} color={colors.grey40} />
        </View>
      </View>
    </Page>
  );
}
